import React from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
} from "reactstrap";
import { useFormik } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import FormButtonHandler from "../../../components/FormButtonHandler";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import useCustomValidation from "../validationSchema";
import { addLeadSource } from "../../../api/leadSource"; 

const AddLeadSource = () => {
    const { t } = useTranslation();
    const { addLeadSourceSchema } = useCustomValidation(); 
    const navigate = useNavigate();

    const { setData, loading, error, success } = useResponse(addLeadSource, () => {
        navigate("/lead-sources/");
    });

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: "",
        },
        validationSchema: addLeadSourceSchema,
        onSubmit: (values) => {
            setData({ data: values, type: "add" });
        },
    });

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs title={`${t("btns.Add")} ${t("Lead Source")}`} />

                <Form
                    className="needs-validation"
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                    }}
                >
                    <Row>
                        <Col md="6">
                            <FormGroup className="mb-3">
                                <Label>{t("Name")}</Label>
                                <Input
                                    name="name"
                                    placeholder={t("Name")}
                                    type="text"
                                    onChange={validation.handleChange}
                                    value={validation.values.name}
                                    invalid={!!(validation.touched.name && validation.errors.name)}
                                />
                                <FormFeedback>{validation.errors.name}</FormFeedback>
                            </FormGroup>
                        </Col>
                    </Row>

                    <FormButtonHandler btnTxt={t("Add")} loading={loading} />

                    <ResultHandler
                        error={error}
                        success={success}
                        successMsg={t("Created Successfully!")}
                    />
                </Form>
            </Container>
        </div>
    );
};

export default AddLeadSource;
